import valuer_api from "../../api/valuer";
import {useEffect, useState} from "react";
import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";
import DatePicker from "react-datepicker";


const ValuerAmendDateInput = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.sectionName
    const identifier = props.identifier

    // Optional
    const field = props.field
    const rowId = props.rowId ? props.rowId : false

    // Sizing
    const width = props.width ? props.width : '100%'
    const height = props.height ? props.height : '100%'
    const minHeight = props.minHeight ? props.minHeight : '48px'
    const minWidth = props.minWidth ? props.minWidth : '0'

    // Value
    const [value, setValue] = useState('')

    // Additional Fields
    const showValueDependantFields = props.showValueDependantFields ? props.showValueDependantFields : false
    const valueDependantFields = props.valueDependantFields ? props.valueDependantFields : []

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (props.value !== undefined) {
            if (props.value === null || props.value === 0) {
                setValue(null);  // explicitly treat 0 as cleared
            } else {
                setValue(props.value * 1000)
            }
        }
    }, [props.value])


    const UpdateValue = (_value) => {
        if (!summaryId || !section || !identifier) return
        console.log("Save")
        let updateTime = Date.now()
        AddToQueue(section, identifier, updateTime)
        let body = { "value": _value !== null ? _value / 1000 : null }
        if (rowId) body["row"] = rowId
        let response = valuer_api.ValuerAmendPut(summaryId, section, identifier, body);
        response.then(
            response => {
                RemoveFromQueue(section, identifier, updateTime)
                UpdateParentValue(identifier, _value !== null ? _value / 1000 : null, rowId)
            }
        ).catch((err) => {
            AddToErroredSaves(section, identifier, updateTime)
            setErrorTitle("Failed to Save")
            setErrorMessage("The request to save a field has failed")
        })
    }

    return (
        <>
            <div className="valuer-amend-date-field-container" style={{width: width, minWidth: minWidth}}>
                {field && field
                    ? <div className="valuer-amend-field-label"> {field} </div>
                    : null
                }
                <div className="valuer-amend-field-input-container"
                     style={{width: width, height: height, minHeight: minHeight, minWidth: minWidth}}>
                    <DatePicker selected={value} dateFormat="dd/MM/yyyy"
                                onChange={(dt) => {
                                    let _time
                                    if (dt) _time = new Date(dt.toString()).setHours(12)
                                    else _time = null
                                    UpdateValue(_time)
                                    }}/>
                </div>
            </div>
            {valueDependantFields && valueDependantFields.map((fields, idx) => {
                return (
                    <>
                        {value && (fields.requirement && value === fields.requirement.value)
                        || value && (fields.antiRequirement && value !== fields.antiRequirement.value)
                            ? <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                           sectionName={section}
                                                           summaryId={summaryId}
                                                           setErrorMessage={setErrorMessage}
                                                           setErrorTitle={setErrorTitle}
                                                           UpdateParentValue={UpdateParentValue}
                                                           AddToQueue={AddToQueue}
                                                           RemoveFromQueue={RemoveFromQueue}
                                                           AddToErroredSaves={AddToErroredSaves}/>

                            : (showValueDependantFields ?
                                <div className="valuer-amend-disabled-container">
                                    <ValuerAmendFieldListHandler fieldList={fields.fields}
                                                                 sectionName={section}
                                                                 summaryId={summaryId}
                                                                 setErrorMessage={setErrorMessage}
                                                                 setErrorTitle={setErrorTitle}
                                                                 UpdateParentValue={UpdateParentValue}
                                                                 AddToQueue={AddToQueue}
                                                                 RemoveFromQueue={RemoveFromQueue}
                                                                 AddToErroredSaves={AddToErroredSaves}/>
                                </div>
                                : null)
                        }
                    </>
                )
            })}
        </>
    )

}

export default ValuerAmendDateInput